import React, { useContext } from 'react';
import useIsFullWidthOnMobile from './useIsFullWidthOnMobile';
import StyledFieldWrapper from './StyledFieldWrapper';
import PortfolioIsReadOnlyContext from '@/lib/contexts/PortfolioIsReadOnlyContext';
import FieldCoachComments from './FieldCoachComments';

type FieldWrapperProps = {
  disableCoachComments: boolean;
  children: React.ReactNode;
};

const FieldWrapper = ({
  disableCoachComments,
  children,
}: FieldWrapperProps) => {
  const portfolioIsReadonly = useContext(PortfolioIsReadOnlyContext);
  const isFullWidthOnMobile = useIsFullWidthOnMobile();

  return (
    <StyledFieldWrapper
      className={isFullWidthOnMobile ? 'mobile-full-width' : undefined}
    >
      {children}
      {!disableCoachComments && !portfolioIsReadonly && <FieldCoachComments />}
    </StyledFieldWrapper>
  );
};

export default FieldWrapper;
